export const consumerFilterPayload = (consumerFilter, product = null, coreDataId = null, type = null) => {
    let payload = {};
    let queryString = "";
    if (Object.keys(consumerFilter).length !== 0) {
        const allProductsConsumerFilter = JSON.parse(JSON.stringify(consumerFilter));
        const productConsumerFilter = allProductsConsumerFilter
            ? Object.keys(allProductsConsumerFilter)
                  .map((ele) => {
                      const _product = `${product}__${coreDataId}`;
                      if (_product === ele && allProductsConsumerFilter[ele].productCoreDataId.toString() === coreDataId.toString()) {
                          return allProductsConsumerFilter[ele].filters;
                      }
                  })
                  .filter((ele) => ele !== undefined && ele !== null)?.[0]
            : undefined;

        if (productConsumerFilter) {
            const keys = Object.keys(productConsumerFilter);
            keys &&
                keys.forEach((key) => {
                    let checkedValue = "";
                    productConsumerFilter[key].forEach((datum) => {
                        if (datum.checked) {
                            if (checkedValue !== "") {
                                checkedValue += ",";
                            }
                            checkedValue += datum.value.replace("(missing)", "").trim();
                        }
                    });
                    if (checkedValue !== "") {
                        if (type === "perProductRespondent") {
                            if (queryString !== "") {
                                queryString += "&";
                            }
                            queryString += key + "=" + checkedValue;
                        } else {
                            payload[key] = checkedValue;
                        }
                    }
                });
        }
    }
    if (type === "perProductRespondent") {
        return queryString;
    } else {
        return payload;
    }
};

export const checkFilterSelection = (cfStoreData) => {
    let toggle = false;
    Object.keys(cfStoreData).forEach((pc) => {
        const filters = cfStoreData[pc]?.filters;
        Object.keys(filters).forEach((bv) => {
            const updatedCheckedState = filters[bv];
            if (updatedCheckedState.some((ele) => ele.checked === true)) {
                toggle = true;
            }
        });
    });
    return toggle;
};

export const filterAcrossProducts = (currentFilterStoreData, productCode, moduleName = "", productsSecondaryData = [], studyTypeMethod = "") => {
    const selectedProductFilters = currentFilterStoreData[productCode].filters;
    const checkedFilters = {};

    Object.keys(selectedProductFilters).forEach((filterCategory) => {
        const filterOptions = selectedProductFilters[filterCategory];
        const checkedOptions = filterOptions.filter((option) => option.checked === true);

        if (checkedOptions.length > 0) {
            checkedFilters[filterCategory] = checkedOptions;
        }
    });

    const missingFilters = {};
    for (const [key, value] of Object.entries(currentFilterStoreData)) {
        const filters = value.filters;
        const filteredFilters = {};
        let submitFlag = false;
        let FilterVariant;

        for (const [key, value] of Object.entries(checkedFilters)) {
            if (key in filters) {
                const missingValues = checkedFilters[key].filter((obj1) => !filters[key].some((obj2) => obj1.value === obj2.value));
                const availableValues = checkedFilters[key].filter((obj1) => filters[key].some((obj2) => obj1.value === obj2.value));
                if (missingValues.length !== 0) {
                    filteredFilters[key] = missingValues;
                }
                if (Object.keys(checkedFilters).length === 1) {
                    const flag = availableValues.length !== 0 ? true : false;
                    submitFlag = flag;
                    FilterVariant = "single";
                } else {
                    FilterVariant = "multiple";
                }
            } else {
                filteredFilters[key] = value;
            }
        }

        const missingFlag = Object.keys(filteredFilters).length !== 0 ? "true" : "false";
        if (moduleName === "cross study comparison") {
            const studyTypeMethodTitle = productsSecondaryData.find((datum) => {
                const productCode = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");

                return `${productCode}__${datum.coreDataId}` === key;
            })?.studyTypeMethodTitle;

            if (studyTypeMethodTitle === studyTypeMethod) {
                missingFilters[key] = {
                    isMissing: missingFlag,
                    submitFlag: submitFlag,
                    filterVariant: FilterVariant,
                    filters: filteredFilters,
                    productCoreDataId: value.productCoreDataId,
                };
            } else {
                missingFilters[key] = {};
            }
        } else {
            missingFilters[key] = {
                isMissing: missingFlag,
                submitFlag: submitFlag,
                filterVariant: FilterVariant,
                filters: filteredFilters,
                productCoreDataId: value.productCoreDataId,
            };
        }
    }
    return missingFilters;
};
